import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as feather from 'feather-icons';
import * as _ from 'lodash';
import { Subject, debounceTime } from 'rxjs';
import { Activity } from 'src/app/common/models/activity';
import { ActivityTemplate } from 'src/app/common/models/activityTemplate';
import { Competency } from 'src/app/common/models/competency';
import { ActivityService } from 'src/app/common/services/activity.service';
import { CompetencyService } from 'src/app/common/services/competency.service';
import { PlanEditService } from 'src/app/common/services/plan-edit.service';
import { ConfirmationDialogComponent, ConfirmDialog } from 'src/app/dialogs/dialog-unsaved-changes/confirmation-dialog.component';
import { DialogExamplePlanComponent } from 'src/app/dialogs/dialog-exampleplan/dialog-exampleplan.component';
import { UserService } from 'src/app/common/services/user.service';
import { DialogLearnMoreComponent } from 'src/app/dialogs/dialog-learn-more/dialog-learn-more.component';

@Component({
    selector: 'app-set-learning',
    templateUrl: './set-learning.component.html',
    styleUrls: ['./set-learning.component.css'],
    standalone: false
})
export class SetLearningComponent implements AfterViewInit, OnInit {

  @ViewChildren('s', { read: ElementRef })
  selects: QueryList<ElementRef<HTMLSelectElement>>;

  @ViewChild('f') form: NgForm;

  @Input() competencies: Competency[]
  @Input() year: number;
  @Input() savedCompetencies: Competency[];

  @Output() toggleButton = new EventEmitter();

  @ViewChild("errorSection", {read: ElementRef}) errorSection!: ElementRef;

  activites: ActivityTemplate[];

  activityDescription = new Subject<Activity>();
  learningActivityNotes = new Subject<string>();

  showErrorBar = false;
  notesLengthError = false;
  otherActicitiesLengthError = false;
  activityhValidator = true;
  activityDescValidator = true;
  otherActivityhValidator = true;
  showMinCompetencyError = false;
  showMaxCompetencyError = false;
  otherActivityTemplateId: string;

  buttonDisabled = false;

  constructor(private activityService: ActivityService, private planEditService: PlanEditService, private dialog: MatDialog, private competencyService: CompetencyService, private cdr: ChangeDetectorRef, private userService: UserService) { }

  ngOnInit() {
    this.activityService.getActivityTemplatesByYear(this.year).subscribe(r => {
      this.activites = r;
      this.otherActivityTemplateId = this.activites.filter(r => r.Name === 'Other')[0]?.Id;
    })
  }
  ngAfterViewInit() {
    feather.replace();
    this.form.statusChanges.subscribe(() => {
      this.planEditService.setIsDirty(this.form.dirty);
      if (this.form.valid)
        this.showErrorBar = false;
    })

    this.learningActivityNotes.pipe(debounceTime(500)).subscribe(() => {
      this.buttonDisabled = true;
      this.toggleButton.emit(this.buttonDisabled);
      const scrubbedCompetencies = this.competencyService.scrubCompetencies(this.competencies);
      this.competencyService.updateCompetencyNotes(scrubbedCompetencies).subscribe(() => {
        this.buttonDisabled = false;
        this.toggleButton.emit(this.buttonDisabled);
      });
    });

    this.activityDescription.pipe(debounceTime(500)).subscribe(r => {
        this.buttonDisabled = true;
        this.toggleButton.emit(this.buttonDisabled);
        this.activityService.putActivity(r).subscribe(() => {
          this.buttonDisabled = false;
          this.toggleButton.emit(this.buttonDisabled);
        });
    });
  }

  onSelectionChange(value: Activity){
    this.buttonDisabled = true;
    this.toggleButton.emit(this.buttonDisabled);
    this.activityService.putActivity(value).subscribe((a) => {
      const competency = this.competencies.find(r => r.Id === a.CompetencyId);
      _.remove(competency.Activities, function (n) { return n.Id === a.Id })
      competency.Activities.push(a);
      this.buttonDisabled = false;
      this.toggleButton.emit(this.buttonDisabled);
    });
  }

  click(competency: Competency) {
    if (competency.Activities?.length <= 7) {
      this.buttonDisabled = true;
      this.toggleButton.emit(this.buttonDisabled);
      this.activityService.postActivity({ Id: "0", CompetencyId: competency.Id, Name: "", Description: "", CreatedOn: new Date(), LastModifiedOn: new Date(), CompletedOn: null, Notes: null, ActivityTemplateId: null, ActivityTemplate: null, Status: 0, EmailReminderOn: null })
      .subscribe((c) => {
        const comp = this.competencies.find(r => r.Id === competency.Id);
        comp.Activities.push(c);
        this.buttonDisabled = false;
        this.toggleButton.emit(this.buttonDisabled);
        this.cdr.detectChanges();
        this.selects.forEach((item) => {
          if(item.nativeElement.id == c.Id){
            item.nativeElement.focus();
          }
        });
    });
  }
  }
  validateForm(): boolean {
    this.activityhValidator = true;
    this.activityDescValidator = true;
    this.competencies.forEach((competency) => {
      if(competency.ActivityNote?.length < 10){
        this.activityhValidator = false;
      }
    });

    this.competencies.forEach((competency) => {
      competency.Activities.forEach((activity=>{
        if(activity.Description !== '' && activity.ActivityTemplateId === this.otherActivityTemplateId){
          if(activity.Description?.length < 10){
            this.activityDescValidator = false;
          }
        }
      }))
    });

    if (!this.form.valid ) {
      this.form.control.markAllAsTouched();
      this.showErrorBar = true;
      this.notesLengthError = false;
      this.otherActicitiesLengthError = false;
    }
    else{
      if(!this.activityhValidator){
        this.notesLengthError = true;
        this.form.control.markAllAsTouched();
      }
      else this.notesLengthError = false;
      if(!this.activityDescValidator){
        this.otherActicitiesLengthError = true;
        this.form.control.markAllAsTouched();
      }
      else this.otherActicitiesLengthError = false;
    }
    return this.form.valid && this.activityhValidator && this.activityDescValidator;
  }

  removeActivity(a: Activity) {
    if (this.planEditService.getIsEditing()) {
      this.openConfirmationDialog(a);
    } else {
      this.buttonDisabled = true;
      this.toggleButton.emit(this.buttonDisabled);
      this.activityService.deleteActivity(a).subscribe(() => {
          const competency = this.competencies.find(r => r.Id === a.CompetencyId);
          _.remove(competency.Activities, function (n) { return n.Name === a.Name && n.Id === a.Id })
          this.buttonDisabled = false;
          this.toggleButton.emit(this.buttonDisabled);
      })
    }
  }

  trackItem(index: any, item: any) {
    return item.name;
  }

  openConfirmationDialog(activity: Activity) {

    const confirm = new ConfirmDialog();
    confirm.title = "Remove Learning Activity from Plan?";
    confirm.message = "Are you sure you want to remove this learning activity?";
    confirm.message2 = "Any reflections you entered while tracking progress for this learning activity will be removed from your plan."
    confirm.okButtonTitle = "Continue";
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '500px',
      panelClass: 'pending-changes',
      data: confirm,
      disableClose: true,
      ariaLabelledBy: 'confirm-desc'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'ok') {
        this.buttonDisabled = true;
        this.toggleButton.emit(this.buttonDisabled);
        this.activityService.deleteActivity(activity).subscribe(() => {
          const competency = this.competencies.find(r => r.Id === activity.CompetencyId);
          _.remove(competency.Activities, function (n) { return n.Id === activity.Id })
          this.buttonDisabled = false;
          this.toggleButton.emit(this.buttonDisabled);
        })
      }
    });
  }

  updateCompetencyOrder() {
    for (let i = 0; i < this.competencies.length; i++) {
      this.competencies[i].Order = i + 1;
    }
  }

  openExampleDialog() {
    this.dialog.open(DialogExamplePlanComponent, {
      width: '875px',
      height: 'auto',
      maxHeight: '80vh',
      panelClass: 'learn-more',
      ariaLabelledBy: 'sample-plan-desc',
      disableClose: true
    });
  }

  //todo: REFACTOR create single component
  saveForLater(competency: Competency, bypassSaveDialog: boolean) {

    const nonOtherCompetencyCount = this.competencies?.filter(r => r.Domain !== "Other")?.length;

    if (nonOtherCompetencyCount <= 2 && competency.Domain !== "Other") {
      this.showMinCompetencyError = true;
      this.validateForm();
      setTimeout(() => {
        if (this.errorSection?.nativeElement) {
          this.errorSection.nativeElement.scrollIntoView({block: "center"});
        }
      }, 0);
    } else if ((nonOtherCompetencyCount > 2 || competency.Domain === "Other") && this.savedCompetencies?.length < 15) {
      this.showMinCompetencyError = false;
      this.showMaxCompetencyError = false;
      if (!bypassSaveDialog)
        this.openSaveDialog(competency);
      else {
        this.saveCompetencyForLater(competency);
      }
    } else if (this.savedCompetencies?.length >= 15) {
      this.renderMaxSaveForLaterCompetencyError();
    }
  }

  //todo: REFACTOR create single component
  remove(competency: Competency) {
    const nonOtherCompetencyCount = this.competencies?.filter(r => r.Domain !== "Other")?.length;

    if (nonOtherCompetencyCount <= 2 && competency.Domain !== "Other") {
      this.showMinCompetencyError = true;
    } else if ((nonOtherCompetencyCount > 2 || competency.Domain === "Other") && this.savedCompetencies?.length < 15) {
      this.showMinCompetencyError = false;
      this.showMaxCompetencyError = false;
      this.openRemoveDialog(competency);
    } else if (this.savedCompetencies?.length >= 15) {
      this.renderMaxSaveForLaterCompetencyError();
    }
  }

  openSaveDialog(competency: Competency) {
    const confirm = new ConfirmDialog();
      confirm.title = "Save for Later?";
      confirm.message = "Are you sure you want to remove this competency from this year’s plan and save it for later?";
      confirm.message2 = ""
      confirm.okButtonTitle = "OK";
      confirm.cancelButtonTitle = "Cancel";
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '425px',
        height: '275px',
        data: confirm,
        disableClose: true,
        ariaLabelledBy: 'confirm-desc'
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'ok') {
          this.saveCompetencyForLater(competency);
        }
      });
  }

  openRemoveDialog(competency: Competency){
    const confirm = new ConfirmDialog();
      confirm.title = "Remove Competency from Plan?";
      confirm.message = "Are you sure you want to remove this competency?";
      confirm.message2 = "Your self-assessment, notes, reflections, and any progress tracked for this competency and its learning activities will be removed from your plan."
      confirm.message3 = "You can also return this competency to your list of saved competencies.";
      confirm.okButtonTitle = "Remove";
      confirm.cancelButtonTitle = "Cancel";
      confirm.thirdButtonTitle = "Save for Later";
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '425px',
        height: '460px',
        data: confirm,
        disableClose: true,
        ariaLabelledBy: 'confirm-desc'
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'ok') {
          this.userService.user().subscribe({next: () => {
            this.competencyService.deleteCompetency(competency).subscribe({next: () => {
              _.remove(this.competencies, function (n) { return n.Id === competency.Id });
              this.updateCompetencyOrder();
              this.cdr.detectChanges();
            }});
          }});
        }
        else if(result == 'third'){
          this.saveForLater(competency, true);
        }
      });
    }

    isEmptyActivity(activites: Activity[]){
      return activites?.filter(r => r.ActivityTemplateId === null)?.length > 0
        || activites?.filter(r => r.ActivityTemplate?.Name === 'Other' && (r.Description === null || r.Description === ''))?.length > 0
    }

    saveCompetencyForLater(competency: Competency){
      this.userService.user().subscribe({next: (user) => {
        competency.UserId = user.Id;
        competency.PlanId = '0';
        this.competencyService.updateCompetencyByUserId(competency).subscribe({next: (competency) => {
          _.remove(this.competencies, function (n) { return n.Id === competency.Id });
          this.savedCompetencies.push(competency);
          this.updateCompetencyOrder();
          this.cdr.detectChanges();
        }});
      }});
    }

    openLearnMoreDialog(comp_name: string, comp: string) {
      this.dialog.open(DialogLearnMoreComponent, {
        width: '875px',
        height: 'auto',
        maxHeight: '80vh',
        panelClass: 'learn-more',
        ariaLabel: 'Learn more about each competency',
        data: {
          comp_name: comp_name,
          comp: comp
        },
        disableClose: true
      });
    }

  //todo: REFACTOR steps save for later and remove button components.
  private renderMaxSaveForLaterCompetencyError() {
    this.showMaxCompetencyError = true;
    this.cdr.detectChanges();
    this.validateForm();
    //wait for DOM to render and then scroll to element
    setTimeout(() => {
      if (this.errorSection?.nativeElement) {
        this.errorSection.nativeElement.scrollIntoView({block: "center"});
      }
    }, 0);
  }
  }
